module.exports = __webpack_public_path__ + "static/img/bg_c.bc4124de.png";